import { replace } from 'connected-react-router';
import compact from 'lodash/compact';
import filter from 'lodash/filter';
import isEmpty from 'lodash/isEmpty';

import { withPreconditions } from 'src/app/hocs/withPreconditions';
import { medications } from 'src/app/router/paths';
import { cartClear } from 'src/app/state/actions';
import { getCartItems } from 'src/app/state/selectors';
import type { Dispatch, RootState } from 'src/app/state/store';

export const requiresCartPresent = withPreconditions(
  (state: RootState) => {
    const cartItems = filter(
      compact(getCartItems(state)),
      ({ fulfillmentId, otcItemId }) => !!fulfillmentId || !!otcItemId
    );

    return !isEmpty(cartItems);
  },
  async (dispatch: Dispatch) => {
    await dispatch(cartClear());
    await dispatch(replace(medications.toPath()));
  }
);
